import {css} from '@emotion/react';
import memoize from 'micro-memoize';
import {getLuminance} from '~/utils/safe-color';

export const highlightOnKeyboardFocusMixin = css`
  &.focus-visible {
    outline: 1px solid gray;
  }
`;

export const highlightOnKeyboardFocusMixinExtra = css`
  &.focus-visible {
    outline: 3px solid gray;
  }
`;

export const screenreaderOnlyMixin = css({
  position: 'absolute !important',
  height: '1px',
  width: '1px',
  overflow: 'hidden',
  clip: 'rect(1px, 1px, 1px, 1px)',
});

export const isDark = memoize(color => getLuminance(color) < 0.333, {maxSize: 10});
